import { CSSProperties } from 'react';
import { COLORS, DISPLAY_STRETCH, FONTS } from '../../globalStyles';

export const styles: Record<string, CSSProperties> = {
  brand: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.65rem',
  },
  markLink: {
    display: 'inline-flex',
  },
  text: {
    display: 'inline-flex',
    alignItems: 'flex-end',
    gap: '0.65rem',
  },
  wordmark: {
    fontFamily: FONTS.display,
    fontStretch: DISPLAY_STRETCH,
    fontWeight: 600,
    fontSize: '1.4rem',
    lineHeight: 1,
    color: COLORS.text,
    textDecoration: 'none',
  },
  endorsement: {
    fontFamily: FONTS.novaeon,
    textTransform: 'uppercase',
    letterSpacing: '0.18em',
    fontWeight: 500,
    fontSize: '0.6rem',
    lineHeight: 1,
    color: COLORS.label,
    paddingBottom: '0.15rem',
    whiteSpace: 'nowrap',
  },
  endorsementLink: {
    display: 'inline-block',
    padding: '0 0.5rem 2.15rem',
    margin: '0 -0.5rem -2.15rem',
    color: COLORS.muted,
    textDecoration: 'underline',
    textDecorationColor: COLORS.borderStrong,
    textUnderlineOffset: '3px',
    transition: 'color 0.15s, text-decoration-color 0.15s',
  },
  endorsementLinkHovered: {
    color: COLORS.text,
    textDecorationColor: COLORS.text,
  },
};
